/* eslint-disable no-unsafe-optional-chaining */
import { OPEN_LINK_IN_BROWSER } from 'core-lib/constants/nativeBridge';
import { passMessageToNative } from 'core-lib/utils/helpers';
import { isParkPlusWebView } from 'core-lib/utils/source';
import { DETAIL_KEYS } from '../constants/constants';
// eslint-disable-next-line import/no-cycle
import { STORAGE_KEY } from '../constants/session';
import { CityMappingType } from '../types/Car';

export const modifyOwnerNum = (value = 1) => {
  if (!value) return '';
  if (value === 1) return `${value}st owner`;
  if (value === 2) return `${value}nd owner`;
  if (value === 3) return `${value}rd owner`;
  return `${value}th owner`;
};

export const numOfDays = (value: string): number => {
  const date1 = Number(new Date(value));
  const date2 = Number(new Date());

  const diffTime = date2 - date1;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  return diffDays;
};

export const capitalizeFirstLetter = (string) => {
  if (typeof string === 'string')
    return string.charAt(0).toUpperCase() + string.slice(1);
};

export function filterAndOrganiseSpecifications(obj) {
  if (!obj || Object.keys(obj).length === 0) {
    return null;
  }

  const newObj = {};

  Object.keys(obj).forEach((key) => {
    const specsKey = obj[key];
    const res = {};

    Object.keys(specsKey).forEach((elKey) => {
      if (specsKey[elKey] != null && specsKey[elKey] !== '-') {
        res[elKey] = specsKey[elKey];
      }
    });

    if (Object.keys(res).length > 0) {
      newObj[DETAIL_KEYS[key]] = res;
    }
  });
  if (Object.keys(newObj).length === 0) {
    return null;
  }
  return newObj;
}

export function getPayload(query) {
  const {
    sortType,
    fuelType,
    brand,
    model,
    yearFrom,
    yearTo,
    kmDrivenMin,
    kmDrivenMax,
    noOfOwners,
    priceLow,
    priceHigh,
    transmission,
    distance,
    bodyType,
    // selectedCity,
    // subscribedInventories,
    hideInventories,
    partnerName,
    did,
  } = query;
  const payload: any = {};

  if (sortType) {
    payload.sort = sortType;
  }
  if (bodyType) {
    if (typeof bodyType === 'string') {
      payload.body_type = [bodyType];
    } else payload.body_type = bodyType;
  }
  if (partnerName) {
    payload.partner_code = partnerName;
  }
  if (transmission) {
    payload.transmission_type = transmission;
  }
  // if (selectedCity) {
  //   if (typeof selectedCity === 'string') {
  //     payload.city_list = [selectedCity];
  //   } else {
  //     payload.city_list = selectedCity;
  //   }
  // } else payload.city_list = ['Delhi'];
  // if (distance) {
  //   payload.lat =
  //     sessionStorage.getItem('lat') || sessionStorage.getItem('native_loc_lat');
  //   payload.lng =
  //     sessionStorage.getItem('long') ||
  //     sessionStorage.getItem('native_loc_lng');
  //   payload.radius = distance;
  // }
  if (fuelType) {
    payload.fuel_type = fuelType.toUpperCase();
  }
  if (brand) {
    if (typeof brand === 'string') {
      payload.brand = [brand];
    } else payload.brand = brand;
  }
  if (model) {
    if (typeof model === 'string') {
      payload.model = [model];
    } else payload.model = model;
  }
  if (yearFrom) {
    payload.man_year_min = yearFrom;
  }
  if (yearTo) {
    payload.man_year_max = yearTo;
  }
  if (kmDrivenMin) {
    payload.km_driven_min = kmDrivenMin;
  }
  if (kmDrivenMax) {
    payload.km_driven_max = kmDrivenMax;
  }
  if (noOfOwners) {
    payload.owner_no = noOfOwners;
  }
  if (priceLow) {
    payload.price_low = +priceLow;
  }
  if (priceHigh) {
    payload.price_high = +priceHigh;
  }
  // if (subscribedInventories === 'true') {
  //   payload.subscribed_inventories = true;
  // } else {
  //   payload.subscribed_inventories = false;
  // }
  if (hideInventories) {
    payload.hide_viewed_inventories = hideInventories === 'true';
  }
  if (did) {
    if (typeof did === 'string') {
      payload.dealer_list = [+did];
    } else payload.dealer_list = did?.map((value) => +value);
  }
  return payload;
}

export function getListingPayload(query) {
  const {
    sortType,
    fuelType,
    brand,
    model,
    yearFrom,
    yearTo,
    kmDrivenMin,
    kmDrivenMax,
    noOfOwners,
    priceLow,
    priceHigh,
    transmission,
    distance,
    bodyType,
    subscribedInventories,
    hideInventories,
    partnerName,
    did,
  } = query;
  const payload: any = {};

  if (sortType) {
    payload.sort = sortType;
  }
  if (bodyType) {
    if (typeof bodyType === 'string') {
      payload.body_type = [bodyType];
    } else payload.body_type = bodyType;
  }
  if (partnerName) {
    payload.partner_code = partnerName;
  }
  if (transmission) {
    if (typeof transmission === 'string') {
      payload.transmission_type = [transmission];
    } else payload.transmission_type = transmission;
  } else payload.city_list = ['Delhi'];
  if (distance) {
    payload.lat =
      sessionStorage.getItem('lat') || sessionStorage.getItem('native_loc_lat');
    payload.lng =
      sessionStorage.getItem('long') ||
      sessionStorage.getItem('native_loc_lng');
    payload.radius = distance;
  }
  if (fuelType) {
    if (typeof fuelType === 'string') {
      payload.fuel_type = [fuelType.toUpperCase()];
    } else payload.fuel_type = fuelType;
  }
  if (brand) {
    if (typeof brand === 'string') {
      payload.brand = [brand];
    } else payload.brand = brand;
  }
  if (model) {
    if (typeof model === 'string') {
      payload.model = [model];
    } else payload.model = model;
  }
  if (yearFrom) {
    payload.man_year_min = yearFrom;
  }
  if (yearTo) {
    payload.man_year_max = yearTo;
  }
  if (kmDrivenMin) {
    payload.km_driven_min = kmDrivenMin;
  }
  if (kmDrivenMax) {
    payload.km_driven_max = kmDrivenMax;
  }
  if (noOfOwners) {
    if (typeof noOfOwners === 'string') {
      payload.owner_no = [noOfOwners];
    } else payload.owner_no = noOfOwners;
  }
  if (priceLow) {
    payload.price_low = +priceLow;
  }
  if (priceHigh) {
    payload.price_high = +priceHigh;
  }
  if (subscribedInventories === 'true') {
    payload.subscribed_inventories = true;
  } else {
    payload.subscribed_inventories = false;
  }
  if (hideInventories) {
    payload.hide_viewed_inventories = hideInventories === 'true';
  }
  if (did) {
    if (typeof did === 'string') {
      payload.dealer_list = [+did];
    } else payload.dealer_list = did?.map((value) => +value);
  }
  return payload;
}

export const getRandomNumByTime = (count) => {
  const time = new Date();
  return time.getMilliseconds() * (count + 10);
};

export const formatPrice = (value: number) => {
  if (!value || Number.isNaN(value)) {
    return value;
  }
  const formatter = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    notation: 'compact',
    compactDisplay: 'long',
  });
  return formatter.format(value);
};

export const handleNavigationClick = (coordinates) => {
  if (coordinates?.lat && coordinates?.lng) {
    const url = `https://www.google.com/maps/search/?api=1&query=${coordinates?.lat},${coordinates?.lng}&travelmode=driving`;

    if (isParkPlusWebView()) {
      passMessageToNative(OPEN_LINK_IN_BROWSER, url);
    } else {
      window.open(url, '_blank');
    }
  }
};

export function formatDistance(distance) {
  if (!distance) {
    return null;
  }
  if (distance < 1000) {
    return `${Math.round(distance)} MTR`;
  } else return `${Math.round(distance / 1000)} KM`;
}

export function processUcdImageKit(img) {
  // if (img?.includes('imagekit')) {
  //   return img;
  // }
  // if (
  //   img?.includes('/production/dealer/public') ||
  //   img?.includes('/production/ucd/public')
  // ) {
  //   const imgArr = img?.split('public');
  //   return `https://ik.imagekit.io/parkplus${imgArr?.[1]}?tr=q-60`;
  // }
  return img;
}

export function handleStoreImage(img) {
  if (
    !img ||
    img ===
      'https://parkplus-bkt-img.parkplus.io/production/testing/public/13834769-mjh-72fc31aa-d1f7-444a-8417-8343f5a2b293.png'
  ) {
    return '/app/img/ucd/dealer-placeholder.webp';
  } else return processUcdImageKit(img);
}

export function setInitiator(query) {
  const savedInitiator = sessionStorage.getItem(STORAGE_KEY.sessionInitiator);
  if (savedInitiator) return;
  const initiator = query?.initiator || 'organic';
  sessionStorage.setItem(STORAGE_KEY.sessionInitiator, initiator);
}

export function getInitiator(query) {
  const savedInitiator = sessionStorage.getItem(STORAGE_KEY.sessionInitiator);
  let initiator = 'organic';
  if (!savedInitiator) {
    if (query?.initiator === 'notification') {
      initiator = 'pwa-notification';
    } else if (query?.initiator === 'ga-notification') {
      initiator = 'growth-notification';
    } else if (query?.initiator === 'ga-society-notification') {
      initiator = 'society-notification';
    }
    sessionStorage.setItem(STORAGE_KEY.sessionInitiator, initiator);
  } else if (
    [
      'notification',
      'ga-notification',
      'organic',
      'society-notification',
    ]?.includes(savedInitiator)
  ) {
    if (savedInitiator === 'notification') {
      initiator = 'pwa-notification';
    } else if (savedInitiator === 'ga-notification') {
      initiator = 'growth-notification';
    } else if (savedInitiator === 'ga-society-notification') {
      initiator = 'society-notification';
    }
  }
  return initiator;
}

export const formatLocationName = (location: string[]): string => {
  if (!location) return '';
  let locationName;
  if (
    typeof location === 'string' ||
    (location?.length && location?.length === 1)
  ) {
    locationName = location?.length ? location[0] : location;
  } else {
    locationName = `${location?.[0]} & ${location?.length - 1} ${
      location?.length - 1 > 1 ? 'other cities' : 'other city'
    }`;
  }
  return locationName;
};

export const capitalizeString = (str: string) => {
  if (str?.toLowerCase() === 'cng') {
    return 'CNG';
  }
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const numberWithCommas = (x) =>
  x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export function getCityText(mappedLocations: CityMappingType[]) {
  if (!mappedLocations?.length) {
    return '-------';
  }
  return `${mappedLocations?.[0]?.city}`;
  // if (mappedLocations?.length === 1) {
  //     return `${mappedLocations?.[0]?.city}`;
  // }
  // if(mappedLocations?.length === 2){
  //   return `${mappedLocations?.[0]?.city} & ${mappedLocations?.[1]?.city}`
  // }
  // else if (mappedLocations?.length > 2) {
  //     return `${mappedLocations?.[0]?.city} & ${mappedLocations?.length - 1} other cities`;
  // }
  // else return '-------';
}

export function getMergedCities(nearbyCities: CityMappingType[]): string[] {
  const cityList = [];
  nearbyCities?.forEach((obj) => {
    cityList?.push(...obj?.mappedCities);
  });
  return cityList;
}
